// ============================================
// Memory Edit Module - State (ES6)
// 메모리 편집 모듈 상태 관리
// ============================================

// ============================================
// 상태 변수
// ============================================

let memoryDb = null;
let currentSessionId = null;
let currentRoomId = null;
let currentUserId = null;

// 레이어별 데이터 캐시
let layerData = {
  entity: [],
  relationship: null,
  event: [],
  quote: [],
  world: null,
  summary: null
};

// 아코디언 상태
let openAccordions = new Set(['world']); // 기본으로 world 열림

// 로딩 상태
let loadingLayers = new Set();

// 편집 상태
let editingItem = null;
let editingLayer = null;

// 페이지네이션 상태 (표시할 아이템 수)
const PAGE_SIZE = 10;
let displayedCounts = {
  event: PAGE_SIZE,
  quote: PAGE_SIZE,
  entity: PAGE_SIZE
};

// ============================================
// Getters
// ============================================

export function getMemoryDb() {
  if (!memoryDb) {
    memoryDb = firebase.firestore();
  }
  return memoryDb;
}

export function getCurrentMemorySessionId() {
  return currentSessionId;
}

export function getCurrentMemoryRoomId() {
  return currentRoomId;
}

export function getCurrentMemoryUserId() {
  return currentUserId;
}

export function getLayerData(layer) {
  return layerData[layer];
}

export function getAllLayerData() {
  return layerData;
}

export function isAccordionOpen(layer) {
  return openAccordions.has(layer);
}

export function getOpenAccordions() {
  return openAccordions;
}

export function isLayerLoading(layer) {
  return loadingLayers.has(layer);
}

export function getEditingItem() {
  return editingItem;
}

export function getEditingLayer() {
  return editingLayer;
}

export function getDisplayedCount(layer) {
  return displayedCounts[layer] || PAGE_SIZE;
}

export function getPageSize() {
  return PAGE_SIZE;
}

// ============================================
// Setters
// ============================================

export function setCurrentMemorySession(userId, roomId, sessionId) {
  currentUserId = userId;
  currentRoomId = roomId;
  currentSessionId = sessionId;
}

export function setLayerData(layer, data) {
  layerData[layer] = data;
}

export function updateLayerItem(layer, itemId, updates) {
  if (Array.isArray(layerData[layer])) {
    const index = layerData[layer].findIndex(item => item.id === itemId);
    if (index !== -1) {
      layerData[layer][index] = { ...layerData[layer][index], ...updates };
    }
  } else if (layerData[layer]) {
    layerData[layer] = { ...layerData[layer], ...updates };
  }
}

export function addLayerItem(layer, item) {
  if (Array.isArray(layerData[layer])) {
    layerData[layer].unshift(item);
  }
}

export function removeLayerItem(layer, itemId) {
  if (Array.isArray(layerData[layer])) {
    layerData[layer] = layerData[layer].filter(item => item.id !== itemId);
  }
}

export function toggleAccordion(layer) {
  if (openAccordions.has(layer)) {
    openAccordions.delete(layer);
  } else {
    openAccordions.add(layer);
  }
}

export function setAccordionOpen(layer, isOpen) {
  if (isOpen) {
    openAccordions.add(layer);
  } else {
    openAccordions.delete(layer);
  }
}

export function setLayerLoading(layer, isLoading) {
  if (isLoading) {
    loadingLayers.add(layer);
  } else {
    loadingLayers.delete(layer);
  }
}

export function setEditingState(layer, item) {
  editingLayer = layer;
  editingItem = item;
}

export function clearEditingState() {
  editingLayer = null;
  editingItem = null;
}

export function loadMoreItems(layer) {
  if (displayedCounts[layer] !== undefined) {
    displayedCounts[layer] += PAGE_SIZE;
  }
}

export function resetDisplayedCount(layer) {
  if (displayedCounts[layer] !== undefined) {
    displayedCounts[layer] = PAGE_SIZE;
  }
}

// ============================================
// 초기화
// ============================================

export function resetLayerData() {
  layerData = {
    entity: [],
    relationship: null,
    event: [],
    quote: [],
    world: null,
    summary: null
  };
  loadingLayers.clear();
  displayedCounts = {
    event: PAGE_SIZE,
    quote: PAGE_SIZE,
    entity: PAGE_SIZE
  };
}

export function resetAllState() {
  currentSessionId = null;
  currentRoomId = null;
  currentUserId = null;
  resetLayerData();
  openAccordions = new Set(['world']);
  clearEditingState();
}
